<template>
  <div class="renewal-info main print-no-padding">
    <info :orderDetail="orderDetail" />
    <packageInfo :orderDetail="orderDetail" />
    <storeInfo :id="id" />
    <toPayFloatingBar
      v-if="!isEmpty(orderDetail)"
      btnText="去支付"
      :pointType="2"
      :pointShow="true"
      :orderStoreSum="orderDetail.orderStoreSum"
      :orderAmount="orderDetail.orderAmount"
      @btnClick="onSubmit"
    />
  </div>
</template>

<script>
import Fetch from '@/api';
import info from '../../components/orderDetail/info.vue';
import packageInfo from '../../components/orderDetail/packageInfo.vue';
import storeInfo from '../../components/orderDetail/storeInfo.vue';
import toPayFloatingBar from '../../../components/toPayFloatingBar/toPayFloatingBar.vue';
import { mapState, mapActions } from 'vuex';
import { ORDER_STATUS } from '@/lib/constant';
import { isEmpty } from '@/util';

export default {
  name: 'renewalInfo',
  components: {
    info,
    packageInfo,
    storeInfo,
    toPayFloatingBar
  },
  computed: {
    ...mapState('renewal', ['paySuccessJump'])
  },
  data() {
    return {
      orderDetail: {},
      id: null
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getRenewalOrderDetail();
    this.onPaySuccessJump(false);
  },
  methods: {
    isEmpty,
    ...mapActions('renewal', ['onPay', 'onPaySuccessJump']),
    async getRenewalOrderDetail() {
      const res = await Fetch.getRenewalOrderDetail({ id: this.id });
      this.orderDetail = res;
    },
    onSubmit() {
      const { name = '' } = this.$route;
      if (name.includes('chain')) {
        Telescope.trackEvent({ trackId: 'zywzpc-event-wzy-fwtctjddqzf' });
      }
      if (name.includes('monomer')) {
        Telescope.trackEvent({ trackId: 'zywzpc-click-storeaccount-submitorders-pay' });
      }
      const { FAIL, PAID, CONTRACT_EFFECT } = ORDER_STATUS;
      const { id, orderStatus } = this.orderDetail;
      if (FAIL === orderStatus) return this.$message('订单已失效');
      if ([PAID, CONTRACT_EFFECT].includes(orderStatus)) return this.$message('订单已支付，请返回查看');
      this.onPay({ id });
    }
  },
  beforeRouteLeave(to, from, next) {
    const {
      paySuccessJump,
      orderDetail: { orderStatus }
    } = this;
    const { FAIL, PAID, CONTRACT_EFFECT } = ORDER_STATUS;
    if (paySuccessJump || [PAID, CONTRACT_EFFECT, FAIL].includes(orderStatus)) {
      next();
    } else {
      setTimeout(() => {
        this.$confirm('您有一笔未支付订单，是否确认退出？', '确定退出', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          customClass: 'confirm',
          type: 'warning',
          center: true
        })
          .then(() => {
            next();
          })
          .catch(() => {
            next(false);
          });
      }, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.renewal-info {
  background: #fff;
  border: 1px solid #f2f2f2;
  -webkit-box-shadow: 0 4px 12px 0 #ededed;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px 16px 20px;
  margin: 0px 0 48px;
}
</style>
